import React, { FC, createContext, useContext, ReactNode } from 'react'
import { useImportTruckListForm } from './useImportTruckListForm'

export const ImportTruckListContext = createContext<ReturnType<typeof useImportTruckListForm>>({
  selectedTrucks: {},
  selectedTruckIds: [],
  changeHandler: () => {},
  createChangeHandler: () => () => {},
  getSelectedByKeyName: () => false,
  toggleAllHandler: () => {},
  allTrucksToggled: false,
})

interface IImportTruckListProviderProps extends ReturnType<typeof useImportTruckListForm> {
  children: ReactNode
}

export const ImportTruckListProvider: FC<IImportTruckListProviderProps> = ({
  children,
  ...props
}) => {
  return <ImportTruckListContext.Provider value={props}>{children}</ImportTruckListContext.Provider>
}

export const useImportTruckListFormContext = () => useContext(ImportTruckListContext)
